/** Follow-up questions under the last answer, about the brotherhood it was about. */
export function FollowUps({
  name,
  questions,
  onPick,
}: {
  name: string;
  questions: string[];
  onPick: (q: string) => void;
}) {
  if (questions.length === 0) return null;
  return (
    <ul className="flex flex-wrap gap-2" aria-label={`Más preguntas sobre ${name}`}>
      {questions.map((q) => (
        <li key={q}>
          <button
            type="button"
            onClick={() => onPick(q)}
            className="min-h-11 rounded-2xl border-2 border-purple/25 bg-white/70 px-3.5 py-2 text-left text-base leading-snug text-ink hover:border-purple focus-visible:outline-2 focus-visible:outline-purple dark:border-cream/20 dark:bg-night-800 dark:text-cream dark:hover:border-gold-300"
          >
            {q}
          </button>
        </li>
      ))}
    </ul>
  );
}
